import { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UploadForm from './upload_form';
import '../../../css/data-grid.css';

function FileUploadSupport_popup() {

    const [data, setData] = useState([]);
    const [list, setList] = useState([]);
    const [atchDta, setAtchDta] = useState([]);
    const [head, setHead] = useState([]);
    const [excelData, setExcelData] = useState({});
    const [output, setOutput] = useState([]);
    const [checked, setChecked] = useState('');
    const [replace, setReplace] = useState([]);
    const [changed, setChanged] = useState([]);
    const sendData = JSON.parse(localStorage.getItem('tableData')) || {};

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/excel_upload_resource.do', {
                params: {
                    tableName: sendData.tableName,
                    tableOwner: sendData.tableOwner,
                }
            });
            setData(response.data);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    const callList = async () => {
        try {
            const response = await axios.get('/trmsapi/obthrc/selectNewSubjList.do', { params: { subType: "spt" } });
            setList(response.data);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const isValidDate = (dateStr, format = 'YYYYMMDD') => {
        if (!/^\d{8}$/.test(dateStr)) return false;
        const year = parseInt(dateStr.substring(0, 4));
        const month = parseInt(dateStr.substring(4, 6));
        const day = parseInt(dateStr.substring(6, 8));
        const date = new Date(year, month - 1, day);
        return (
            date.getFullYear() === year &&
            date.getMonth() + 1 === month &&
            date.getDate() === day
        );
    };

    const isValidDate2 = (dateStr) => {
        console.log(!/^\d{8}$/.test(dateStr));
        console.log(!dateStr.includes('-'));
        if (!/^\d{6}-\d{1}$/.test(dateStr)) {
            return false;
        }
        return dateStr;
    };

    const uploadCheckValidation = (rowData, rowIndex) => {
        try {
            const getValue = (col) => (rowData[col] || '').toString().trim();
            const OnlyNumpattern = /^[0-9]+$/;

            let [sbjectCd, nm, resiRegNo, lcnsNo, lcnsDt, spclstNo, spclstRegDt, spclstBeginDt, spclstEndDt, endReason, lbcstAt, lbcstBeginDt, lbcstEndDt, oesHumanInfo, crdtInitDt, bigo
            ] = [
                'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P'
            ].map(getValue);
            const rowIdx = rowIndex + 1;
            const isEmpty = (value) => !value || value.replace(/\s/g, "") === "";
            const stripDash = (value) => value?.replace(/-/g, '');
            if (isEmpty(sbjectCd)) {
                alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 전문과목 항목은 필수값입니다.`);
                return false;
            }
            if (isEmpty(nm)) {
                alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 성명은 필수값입니다.`);
                return false;
            }
            if (!isEmpty(resiRegNo)) {
                if (!isValidDate2(resiRegNo)) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n생년월일을 다시 입력해주세요. (ex920709-1)`);
                    return false;
                }
            } else {
                alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 생년월일은 필수값입니다.`);
                return false;
            }
            if (!isEmpty(spclstNo)) {
                if (!OnlyNumpattern.test(spclstNo)) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 지원전문의 자격번호는 숫자 형식으로만 입력되어야 합니다.`);
                    return false;
                }
                if (!isEmpty(spclstRegDt)) {
                    if (spclstRegDt.includes('/')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. '/'는 사용할 수 없습니다.`);
                        return false;
                    }
                    const regDate = stripDash(spclstRegDt);
                    if (!OnlyNumpattern.test(regDate) || !isValidDate(regDate, 'YYYYMMDD')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 자격 취득일은 날짜 형식이어야 합니다.`);
                        return false;
                    }
                } else {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n지원전문의 근무 시작일을 작성해주세요.`);
                    return false;
                }
            } else {
                alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 지원전문의 자격번호는 필수값입니다.`);
                return false;
            }
            if (!isEmpty(lcnsNo)) {
                if (!OnlyNumpattern.test(lcnsNo)) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 의사 면허번호는 숫자 형식으로만 입력되어야 합니다.`);
                    return false;
                }
                if (!isEmpty(lcnsDt)) {
                    if (lcnsDt.includes('/')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. '/'는 사용할 수 없습니다.`);
                        return false;
                    }
                    const date = stripDash(lcnsDt);
                    if (!OnlyNumpattern.test(date) || !isValidDate(date, 'YYYYMMDD')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 면허 취득일은 날짜 형식이어야 합니다.`);
                        return false;
                    }
                } else {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n의사면허 취득일을 작성해주세요.`);
                    return false;
                }
            } else {
                alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 의사 면허번호는 필수값입니다.`);
                return false;
            }
            if (!isEmpty(spclstEndDt)) {
                if (spclstEndDt.includes('/')) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다. '/'는 사용할 수 없습니다.`);
                    return false;
                }
                const endDt = stripDash(spclstEndDt);
                const beginDt = stripDash(spclstBeginDt);
                if (!OnlyNumpattern.test(endDt) || !isValidDate(endDt, 'YYYYMMDD')) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n지원전문의 근무 종료일을 입력해주세요.`);
                    return false;
                }
                if (beginDt > endDt) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 종료일은 시작일보다 먼저일 수 없습니다.`);
                    return false;
                }
                if (isEmpty(endReason)) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n근무 종료 사유를 입력해주세요.`);
                    return false;
                }
            }
            if (lbcstAt === '국비' || lbcstAt === 'Y') {
                if (!isEmpty(lbcstBeginDt)) {
                    if (lbcstBeginDt.includes('/')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. '/'는 사용할 수 없습니다.`);
                        return false;
                    }
                    const begin = stripDash(lbcstBeginDt);
                    const end = stripDash(spclstEndDt);
                    if (!OnlyNumpattern.test(begin) || !isValidDate(begin, 'YYYYMMDD')) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n국비수당 지원 시작일을 입력해주세요.`);
                        return false;
                    }
                    if (begin > end) {
                        alert(`${rowIdx}번째 행이 잘못 입력됐습니다. 국비수당 지원 종료일은 시작일보다 먼저일 수 없습니다.`);
                        return false;
                    }
                }
            }
            if (!isEmpty(oesHumanInfo)) {
                if (!['A2200001', 'A1100014', 'A1400001'].includes(sendData.emogcode)) {
                    alert(`${rowIdx}번째 행이 잘못 입력됐습니다.\n\n연세세브란스병원, 의료재단길병원, 고려대학교구로병원인 경우에만 외상수련기관을 입력할 수 있습니다`);
                    return false;
                }
            }
            return true;
        } catch (e) {
            alert(`[uploadCheckValidation] error: ${e.message}`);
            return false;
        }
    };

    const formatDate = (val) => {
        if (!val || val.length !== 8) return val;
        return `${val.substring(0, 4)}-${val.substring(4, 6)}-${val.substring(6, 8)}`;
    };

    const uploadReplaceValue = (row) => {
        try {
            const newRow = { ...row };
            // 날짜 포맷
            newRow.E = formatDate(newRow.E) || ''; // 외상센터 근무 시작일
            newRow.G = formatDate(newRow.G) || ''; // 외상센터 근무 종료일
            newRow.H = formatDate(newRow.H) || ''; // 전담전문의 근무 시작일
            newRow.I = formatDate(newRow.I) || ''; // 전담전문의 근무 종료일
            newRow.L = formatDate(newRow.L) || ''; // 전담전문의 근무 종료일
            newRow.M = formatDate(newRow.M) || ''; // 전담전문의 근무 종료일
            newRow.O = formatDate(newRow.O) || ''; // 전담전문의 근무 종료일
            return newRow;
        } catch (e) {
            console.error('uploadReplaceValue error:', e);
            alert(`[uploadReplaceValue] 오류: ${e.message}`);
            return row;
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files[0] !== undefined) {
            setAtchDta(e.target.files[0]); //TF로 변경
            const file = e.target.files[0];
            const reader = new FileReader();

            reader.onload = (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: 'base64' });
                const headers = {};
                Object.keys(wb.SheetNames).forEach((i) => {
                    const wsname = wb.SheetNames[i];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
                    return headers[wsname] = data[0];
                });
                setChecked(wb.SheetNames[0]);
                setOutput(wb.SheetNames[0]);
                setHead(headers);
                setExcelData(to_json(wb));
                console.log(to_json(wb));
            };
            reader.readAsArrayBuffer(file);
        } else {
            setAtchDta([]);
            setHead([]);
            setExcelData([]);
            setOutput([]);
            setChecked('');
            setChanged([]);
            return;
        }
    };

    const to_json = (workbook) => {
        const result = {};
        workbook.SheetNames.forEach((sn) => {
            const sheet = workbook.Sheets[sn];
            const rows = XLSX.utils.sheet_to_json(sheet, {
                header: 'A',     // 첫 행을 header로 사용
                defval: '',      // 빈 셀은 공백 처리
            });
            if (rows.length > 0) {
                result[sn] = rows;
            }
        });
        return result;
    };

    const initChanged = (head, data) => {
        if (head === undefined) {
            return;
        } else {
            const mapped = head.reduce((acc, row, idx) => {
                const key = String.fromCharCode(65 + idx);
                const item = data.find(item => item.COMMENTS === row);
                const value = item ? item.COLUMN_NAME : '';
                acc[key] = value;
                return acc;
            }, {});
            setChanged(mapped);
        };
    }

    const save = async () => {
        if (atchDta.length === 0) {
            alert('선택된 파일이 없습니다.');
            return false;
        }
        if (changedValid(changed) === 'T') {
            alert('중복 선택한 항목이 있습니다. ');
            return false;
        }
        const real = replace.map((row) => ({
            ...row,
            A: list.filter((i) => i.CD_NM === row.A).map(item => item.CD)[0]
        }));
        real.unshift(changed);
        saveLogic(real, "/trmsapi/obthrc/new_excel_upload_support.do");
    };

    const saveLogic = async (data, url) => {
        const payload = new URLSearchParams({
            emogcode: sendData.emogCode,
            excData: JSON.stringify(data),
            userId: localStorage.getItem("id"),
        });

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: payload,
            });

            if (!response.ok) {
                throw new Error(`서버 오류: ${response.status}`);
            }

            const resultText = await response.text();
            console.log('저장 결과:', resultText);

            alert('저장이 완료되었습니다.');
        } catch (error) {
            console.error('저장 중 오류 발생:', error);
            alert('저장에 실패했습니다. 관리자에게 문의하세요.');
        }
    }

    const exit = () => {
        window.close();
    }

    const handelOptions = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...changed,
            [name]: value
        };
        setChanged(newParams);
    };

    const changedValid = (change) => {
        var result = 'F';
        var length = head[checked].length
        for (var i = 0; i < length; i++) {
            var key = change[String.fromCharCode(65 + i)];
            if (Object.values(change).filter((i) => key === i).length > 1) {
                result = 'T';
                break;
            }
        }
        return result;
    }

    useEffect(() => {
        popupData();
        callList();
    }, []);

    useEffect(() => {
        initChanged(head[checked], data);
        const currentSheet = excelData[checked];
        console.log(currentSheet);
        if (!currentSheet || !Array.isArray(currentSheet)) {
            setReplace([]);
            return;
        }
        var flag = 'N';
        const processed = currentSheet.slice(1).map((row, Idx) => {
            if (!uploadCheckValidation(row, Idx)) flag = 'Y';
            return uploadReplaceValue(row);
        });
        setReplace(flag === 'N' ? processed : []);
    }, [excelData]);

    return (
        <UploadForm
            atchDta={atchDta}
            handleFileChange={handleFileChange}
            setChecked={setChecked}
            checked={checked}
            output={output}
            sendData={sendData}
            excelData={excelData}
            replace={replace}
            head={head}
            data={data}
            handelOptions={handelOptions}
            save={save}
            exit={exit}
            title={"지원전문의"}
            changed={changed}
        />
    );
}


export default FileUploadSupport_popup;